import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CreditInstitute } from '../../../common/model/credit-institute';
import { PagedObjectManagerComponent } from '../../../core/component/paged-object-manager/paged-object-manager';
import { FilterDefinitionItem } from '../../../core/model/filter-definition-item';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { CreditInstituteService } from '../../service/credit-institute.service';

@Component({
    selector: 'app-credit-institute-manager',
    templateUrl: './../../../core/component/paged-object-manager/paged-object-manager.html',
    styleUrls: ['./../../../core/component/paged-object-manager/paged-object-manager.scss'],
    providers: [CommandHandlerResolver, CreditInstituteService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreditInstituteManagerComponent extends PagedObjectManagerComponent<CreditInstitute> {
  constructor(
    columnFactory: ColumnDefinitionFactory,
    dispatcher: CommandDispatcher,
    handlerResolver: CommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService,
    private _service: CreditInstituteService
  ) {
    super(_service, messageService, navigationService, dispatcher, handlerResolver);

    this.columnDefinition = [
      columnFactory.create('MORTGAGE.CREDIT_INSTITUTE', 'name'),
      columnFactory.create('COMPANY.ORGANIZATION_NUMBER', 'organizationNumber'),
    ];

    this.title = 'MORTGAGE.CREDIT_INSTITUTES';
    this.preferencesKey = 'mortgage.credit-institute.list';
  }

  ngOnInit() {
    super.ngOnInit();
    this.AddSubscription(
      this._service.getFilterDefinition().subscribe(definition => {
        this.filterDefinition = [
          new FilterDefinitionItem(
            'MORTGAGE.CREDIT_INSTITUTE',
            'name',
            definition.filter.name,
            null,
            definition.filter.selectedFields.includes('name')
          ),
          new FilterDefinitionItem(
            'COMPANY.ORGANIZATION_NUMBER',
            'organizationNumber',
            definition.filter.organizationNumber,
            null,
            definition.filter.selectedFields.includes('organizationNumber')
          ),
        ];
      })
    );
  }
}
